import { HugeiconsIcon } from '@hugeicons/react';
import { Flag01Icon, UserIcon, CalendarMinus01Icon } from '@hugeicons/core-free-icons';
import { dateToHumanFormatShortWithTime } from "../../utils/constants";

function FlagBanner({ clientFlagged }) {
    return (
        <div className="flex items-start gap-4 p-4 rounded-xl border border-red-100 dark:border-red-500/20 bg-red-50/60 dark:bg-red-500/30" role="alert">
            <div className="flex-shrink-0 w-8 h-8 rounded-full bg-red-100 dark:bg-red-500/20 flex items-center justify-center mt-0.5">
                <HugeiconsIcon icon={Flag01Icon} size={15} className="text-red-600 dark:text-red-400" />
            </div>

            <div className="flex-1 min-w-0">
                <p className="text-sm font-semibold text-red-700 dark:text-red-400 mb-2">Client account has been flagged</p>

                <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-1.5">
                    <div>
                        <span className="text-xs font-medium text-red-400 dark:text-red-500 uppercase tracking-wide">Reason</span>
                        <p className="text-sm text-red-800 dark:text-red-300 font-medium mt-0.5">{clientFlagged?.reason}</p>
                    </div>

                    {clientFlagged?.recommendation && (
                        <div>
                            <span className="text-xs font-medium text-red-400 dark:text-red-500 uppercase tracking-wide">Recommendation</span>
                            <p className="text-sm text-red-800 dark:text-red-300 mt-0.5">{clientFlagged?.recommendation}</p>
                        </div>
                    )}

                    <div className="inline-flex items-center gap-1.5 mt-1">
                        <HugeiconsIcon icon={UserIcon} size={13} className="text-red-400 dark:text-red-500 shrink-0" />
                        <span className="text-sm text-red-700 dark:text-red-400">{clientFlagged?.flaggedBy}</span>
                    </div>

                    <div className="inline-flex items-center gap-1.5 mt-1">
                        <HugeiconsIcon icon={CalendarMinus01Icon} size={13} className="text-red-400 dark:text-red-500 shrink-0" />
                        <span className="text-sm text-red-700 dark:text-red-400">{dateToHumanFormatShortWithTime(clientFlagged?.createdAt)}</span>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default FlagBanner;
